import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input } from '@cuito/ui';
import type { TenantLoginResponse } from '@cuito/types';
import { apiClient } from '../lib/apiClient';
import { useAuthStore } from '../stores/authStore';

export default function LoginPage() {
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await apiClient.post<TenantLoginResponse>('/auth/tenant/login', {
        username,
        password,
      });
      setSession({ accessToken: res.accessToken, refreshToken: res.refreshToken, user: res.user });
      navigate('/', { replace: true });
    } catch (err) {
      const message =
        (err as { response?: { data?: { message?: string } } })?.response?.data?.message ??
        '登录失败，请稍后重试';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex h-full w-full items-center justify-center bg-white p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-lg border-2 border-black bg-white p-6"
      >
        <h1 className="mb-6 text-center text-2xl font-bold">CUITO 社团管理平台</h1>

        <div className="flex flex-col gap-4">
          <Input
            label="用户名"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
          <Input
            label="密码"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {error && <p className="mt-4 text-sm font-bold text-red-600">{error}</p>}

        <Button type="submit" className="mt-6 w-full" disabled={submitting}>
          {submitting ? '登录中...' : '登录'}
        </Button>
      </form>
    </div>
  );
}
